//Get array of elements with a specific className
export default function getArrayElementsByClass(className) {
  const rows = document.querySelectorAll(className)
  return [].slice.call(rows)
}
